import { createAsyncThunk } from "@reduxjs/toolkit";
import { bffApi } from "../../../../autogen/bff-api";
import { ContractState } from "../../reducers/contractReducer";

export const loadContractThunk = createAsyncThunk(
  "contract/load",
  async (
    props: {
      contractId: string;
    },
    { dispatch, rejectWithValue }
  ) => {
    try {
      const contract = await dispatch(
        bffApi.endpoints.getContract.initiate({ contractId: props.contractId }, { forceRefetch: true })
      ).unwrap();
      const loaded: ContractState = {
        id: contract.id,
        contract: contract as ContractState["contract"],
        lastChanged: contract.modifiedAt,
        errors: [],
      };
      return loaded;
    } catch (e) {
      return rejectWithValue(e);
    }
  }
);
